/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { ArrowDim4DiagMinIcon16Light } from './ArrowDim4DiagMinIcon16Light';
import { ArrowDim4DiagMinIcon16Regular } from './ArrowDim4DiagMinIcon16Regular';
import { ArrowDim4DiagMinIcon16Solid } from './ArrowDim4DiagMinIcon16Solid';
import { ArrowDim4DiagMinIcon20Light } from './ArrowDim4DiagMinIcon20Light';
import { ArrowDim4DiagMinIcon20Regular } from './ArrowDim4DiagMinIcon20Regular';
import { ArrowDim4DiagMinIcon20Solid } from './ArrowDim4DiagMinIcon20Solid';
import { ArrowDim4DiagMinIcon24Regular } from './ArrowDim4DiagMinIcon24Regular';
import { ArrowDim4DiagMinIcon24Solid } from './ArrowDim4DiagMinIcon24Solid';
import { ArrowDim4DiagMinIcon32Regular } from './ArrowDim4DiagMinIcon32Regular';
import { ArrowDim4DiagMinIcon64Regular } from './ArrowDim4DiagMinIcon64Regular';
var sizes = {
    16: {
        light: ArrowDim4DiagMinIcon16Light,
        regular: ArrowDim4DiagMinIcon16Regular,
        solid: ArrowDim4DiagMinIcon16Solid,
    },
    20: {
        light: ArrowDim4DiagMinIcon20Light,
        regular: ArrowDim4DiagMinIcon20Regular,
        solid: ArrowDim4DiagMinIcon20Solid,
    },
    24: {
        regular: ArrowDim4DiagMinIcon24Regular,
        solid: ArrowDim4DiagMinIcon24Solid,
    },
    32: {
        regular: ArrowDim4DiagMinIcon32Regular,
    },
    64: {
        regular: ArrowDim4DiagMinIcon64Regular,
    },
};
export var ArrowDim4DiagMinIcon = forwardRef('ArrowDim4DiagMinIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
